/*============================================================================
  Cart rewards — remove handler only.
  The rewards bar itself is rendered in Liquid (snippets/cart-rewards-bar.liquid)
  and updated automatically when CartForm rebuilds the cart from cart.ajax.liquid.
==============================================================================*/
(function () {
  'use strict';

  var rewardsRefreshInFlight = null;

  // Remove handler — changeItem(key, 0) directly since quantityChanged guards against qty=0
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-remove-key]');
    if (!btn) return;
    var key = btn.dataset.removeKey;
    if (!key) return;
    theme.cart.changeItem(key, 0).then(function () {
      document.dispatchEvent(new CustomEvent('cart:build'));
    });
  });

  /*
    Animate the rewards fill bar. The bar is re-rendered as fresh HTML on every
    cart update, so a CSS width transition has no "from" value to animate from.
    We remember the last width and, when a new fill element appears, snap it to
    the old width then transition to the target on the next frame.
  */
  var lastFillWidth = null;

  function getRefreshableRewards() {
    return document.querySelector('[data-rewards-refreshable]');
  }

  function getSectionRenderUrl(currentBox) {
    if (!currentBox) return null;

    var section = currentBox.closest('[data-section-id]');
    var sectionId = section && section.getAttribute('data-section-id');
    if (!sectionId) return null;

    var url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  function refreshRewardsBox() {
    var currentBox = getRefreshableRewards();
    var sectionUrl = getSectionRenderUrl(currentBox);

    if (!currentBox || !sectionUrl || rewardsRefreshInFlight) return rewardsRefreshInFlight;

    rewardsRefreshInFlight = fetch(sectionUrl, {
      credentials: 'same-origin',
      method: 'GET'
    })
      .then(function (response) { return response.text(); })
      .then(function (htmlText) {
        var html = document.createElement('div');
        html.innerHTML = htmlText;

        var nextBox = html.querySelector('[data-rewards-refreshable]');
        var liveBox = getRefreshableRewards();

        if (nextBox && liveBox) {
          liveBox.replaceWith(nextBox);
        }
      })
      .catch(function (e) { console.error(e); })
      .finally(function () {
        rewardsRefreshInFlight = null;
      });

    return rewardsRefreshInFlight;
  }

  function animateFill() {
    var fill = document.querySelector('.cart-rewards__fill[data-fill-target]');
    if (!fill) return;
    var target = parseFloat(fill.dataset.fillTarget) || 0;

    if (lastFillWidth !== null && lastFillWidth !== target) {
      // Start from the previous width (no transition), then animate to target.
      fill.style.transition = 'none';
      fill.style.width = lastFillWidth + '%';
      // Force reflow so the starting width is committed before transitioning.
      void fill.offsetWidth;
      fill.style.transition = '';
      fill.style.width = target + '%';
    }
    lastFillWidth = target;
  }

  // Watch the cart products container — the rewards bar is rebuilt inside it on
  // every cart change, so a childList mutation is the exact moment to animate.
  function observeCart() {
    var containers = document.querySelectorAll('[data-products]');
    containers.forEach(function (container) {
      var observer = new MutationObserver(function () { animateFill(); });
      observer.observe(container, { childList: true, subtree: true });
    });
    animateFill(); // capture initial width
  }

  document.addEventListener('ajaxProduct:added', refreshRewardsBox);
  document.addEventListener('cart:updated', refreshRewardsBox);
  document.addEventListener('cart:build', refreshRewardsBox);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCart);
  } else {
    observeCart();
  }
})();
